export default {
    day: '2023-10-01',
    content: {
        meta: [
            {
                type: 'bugfix',
                text: '45',
            },
            {
                type: 'clarity',
                text: '46',
            },
            {
                type: 'qol',
                text: '67',
            },
            {
                type: 'qol',
                text: '71',
            }
        ],
        mining: [
            {
                unlock: 'miningDepthDweller',
                type: 'change',
                text: '56',
            },
            {
                unlock: 'miningDepthDweller',
                type: 'change',
                text: '57',
            },
            {
                unlock: 'miningDepthDweller',
                type: 'qol',
                text: '58',
            },
            {
                unlock: 'miningDepthDweller',
                type: 'balance',
                text: '59',
                balance: 'buff',
                before: '1m',
                after: '0.5m',
            },
            {
                type: 'clarity',
                text: '66',
            },
            {
                unlock: 'achievementFeature',
                type: 'new',
                text: 'secretAchievement',
                params: [1]
            }
        ],
        note: [
            {
                type: 'clarity',
                text: '47',
            },
            {
                type: 'bugfix',
                text: '88',
            }
        ],
        gem: [
            {
                unlock: 'miningPickaxeCrafting',
                type: 'clarity',
                text: '70',
            },
            {
                type: 'change',
                text: '77',
            }
        ],
        village: [
            {
                type: 'qol',
                text: '68',
            }
        ],
        achievement: [
            {
                type: 'clarity',
                text: '83',
            }
        ],
        school: [
            {
                unlock: 'schoolLiteratureSubfeature',
                type: 'qol',
                text: '61',
            },
            {
                unlock: 'schoolLiteratureSubfeature',
                type: 'change',
                text: '62',
            },
            {
                unlock: 'schoolLiteratureSubfeature',
                type: 'balance',
                text: '63',
            },
            {
                type: 'clarity',
                text: '64',
            },
            {
                type: 'clarity',
                text: '65',
            },
            {
                type: 'new',
                text: '69',
            }
        ],
        horde: [
            {
                unlock: 'hordeEquipment',
                type: 'qol',
                text: '51',
            },
            {
                unlock: 'hordeEquipment',
                type: 'qol',
                text: '52',
            },
            {
                unlock: 'hordeDamageTypes',
                type: 'clarity',
                text: '53',
            },
            {
                unlock: 'hordeEquipment',
                type: 'qol',
                text: '54',
            },
            {
                type: 'bugfix',
                text: '60',
            },
            {
                unlock: 'hordeEquipment',
                type: 'qol',
                text: '78',
            },
            {
                unlock: 'hordeEquipment',
                type: 'clarity',
                text: '79',
            },
            {
                unlock: 'hordePrestige',
                type: 'context',
                text: '89',
            },
            {
                type: 'balance',
                text: '74',
                balance: 'buff',
                before: '10',
                after: '1',
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '55',
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '85',
                balance: 'nerf',
                before: '2',
                after: '1.5',
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '84',
                balance: 'buff',
                before: '14%',
                after: '16%',
            },
            {
                unlock: 'hordePrestige',
                type: 'remove',
                text: '80',
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '76',
                balance: 'buff',
                before: '35%',
                after: '60%',
            },
            {
                unlock: 'hordePrestige',
                type: 'balance',
                text: '75',
                balance: 'nerf',
                before: '5%',
                after: '2.5%',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '86',
                balance: 'nerf',
                before: '14% - 30%',
                after: '5%',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '87',
                balance: 'buff',
                before: '-0.5%',
                after: '-0.1%',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'remove',
                text: '81',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '73',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'balance',
                text: '72',
                balance: 'buff',
                before: '25%',
                after: '5%',
            },
            {
                unlock: 'hordeHeirlooms',
                type: 'remove',
                text: '82',
            }
        ],
        card: [
            {
                type: 'clarity',
                text: '49',
            }
        ],
        general: [
            {
                type: 'clarity',
                text: '50',
            }
        ],
        farm: [
            {
                type: 'qol',
                text: '48',
            }
        ]
    }
}
